export enum Commands {
    INSERT_CODE = '/insert-dummy-code',
    COMMAND_WITH_PROMPT = '/with-prompt',
    SHOW_STICKY_CARD = '/show-sticky-card',

    REPLACE_FOLLOWUPS = '/replace-followups',
    STATUS_CARDS = '/cards-with-status-colors',
    HEADER_TYPES = '/cards-header-types',
    SUMMARY_CARD = '/cards-summary',
    FORM_CARD = '/card-with-a-form',
    CARD_WITH_MARKDOWN_LIST = '/card-with-markdown-list',
    CARD_WITH_PROGRESSIVE_FILE_LIST = '/card-with-progressive-file-list',
    CARD_WITH_ALL_MARKDOWN_TAGS = '/card-with-all-markdown-tags',
    CARD_RENDER_MARKDOWN_TABLE = '/card-render-markdown-table',
    CARD_SNAPS_TO_TOP = '/card-snaps-to-top',
    FILE_LIST_CARD = '/card-with-a-file-list',
    PROGRESSIVE_CARD = '/card-with-progressing-content',
    IMAGE_IN_CARD = '/card-with-image-inside',
    CUSTOM_RENDERER_CARDS = '/cards-with-custom-renderers',
    FOLLOWUPS_AT_RIGHT = '/followups-at-right',
    INFORMATION_CARDS = '/information-cards',
    CONFIRMATION_BUTTONS = '/confirmation-buttons',
    BUTTONS = '/buttons',
    BORDERED_CARDS = '/bordered-cards',

    NOTIFY = '/show-notification',
    CLEAR = '/clear',
    CLEAR_CONTEXT_ITEMS = '/clear-context-items',
    CLEAR_LOGS = '/clear-logs',
    SHOW_CUSTOM_FORM = '/show-custom-form',
    VOTE = '/vote',

    // Tab header introduction examples
    OPEN_TAB_HEADER_CENTERED = '/tab-header-centered',
    OPEN_TAB_HEADER_WITH_TIP = '/tab-header-with-tip',
    OPEN_WELCOME_INTRO_TAB = '/welcome-intro',
    OPEN_NO_ICON_CENTERED_TAB = '/tab-header-no-icon-centered',
}
